export default __webpack_public_path__ + "static/media/c.5c9a6942.jpg";